import React from 'react'
import { Button, DropdownMenu, Flex } from '@workwhile/ui'
import { EllipsisVertical, Pencil, Trash2 } from 'lucide-react'
import { createGlobalStyle } from 'styled-components'
import { usePositionDetailContextValue } from '../context/PositionDetailProvider'
import { usePositionDetailWorkflowsContextValue } from '../context/PositionDetailWorkflowProvider'

// Fix the z-index of the dropdown menu to appear above the table
// Radix poppers render in a portal, so we need a global style to fix the z-index
const DropdownZIndexFix = createGlobalStyle`
  [data-radix-popper-content-wrapper] {
    z-index: 100 !important;
  }
`

type ActionsCellProps = {
  requirement: ReturnType<
    typeof usePositionDetailContextValue
  >['state']['requirements'][number]
}

export const ActionsCell = ({ requirement }: ActionsCellProps) => {
  const {
    state: { id: positionId },
  } = usePositionDetailContextValue()
  const { editRequirementFlow, unassignRequirementFlow } =
    usePositionDetailWorkflowsContextValue()

  return (
    <>
      <DropdownZIndexFix />
      <Flex justifyContent="center" alignItems="center" width="100%">
        <DropdownMenu
          trigger={
            <Button variant="secondary" kind="small" px={1}>
              <EllipsisVertical size={14} />
            </Button>
          }
        >
          <DropdownMenu.Item
            onClick={() =>
              editRequirementFlow.open({ positionId, requirement })
            }
          >
            <Flex gap={2} alignItems="center">
              <Pencil size={14} />
              Edit
            </Flex>
          </DropdownMenu.Item>
          <DropdownMenu.Item
            onClick={() =>
              unassignRequirementFlow.open({ positionId, requirement })
            }
          >
            <Flex gap={2} alignItems="center">
              <Trash2 size={14} />
              Remove
            </Flex>
          </DropdownMenu.Item>
        </DropdownMenu>
      </Flex>
    </>
  )
}
